export default "__VITE_ASSET__jg0TTOgz__"